import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  fbIcon: SafeResourceUrl = '../../assets/icons/facebook-icon.svg';
  igIcon: SafeResourceUrl = '../../assets/icons/ig-icon.svg';
  linkedinIcon: SafeResourceUrl = '../../assets/icons/linkedin-icon.svg';
  ytIcon: SafeResourceUrl = '../../assets/icons/yt-icon.svg';

  constructor() {}

  ngOnInit(): void {}

  get year(): number {
    return new Date().getFullYear();
  }
}
